export default __webpack_public_path__ + "static/media/background_blob.d2615246.svg";